import React, { Descriptions, Col, Row, Typography } from "antd";
import styles from './descriptions.module.scss';

export const StatusDescriptions = ({ deviceStatus }) => {
    const deviceOn = deviceStatus && deviceStatus.devicesHabilitado && deviceStatus.devicesHabilitado.substring(0, 1) === "0";
    const typeBlock = deviceStatus && deviceStatus.tipoBlk === 0;
    const block = deviceStatus && deviceStatus.bloqueador === 0;
    const reasonBlock = deviceStatus && deviceStatus.devicesBloqueado && deviceStatus.devicesBloqueado.substring(0, 1) === "0";
    const jamming = deviceStatus && deviceStatus.jamming && String(deviceStatus.jamming).charAt(0) === '0';
    const roteirizador = deviceStatus && deviceStatus.roteirizador && deviceStatus.roteirizador.substring(0, 1) === "0";
    const {Title, Text} = Typography;

    return (
        <>

            <Row>
                <Col span={11}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '16px', fontWeight: '700', backgroundColor: 'rgba(80, 154, 204, 0.5)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '30px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="SISTEMA" className={styles.customDescriptionSystem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>{deviceOn ? "Desabilitado" : "Habilitado"}</Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>

                <Col span={5} offset={8}>
                    <h6 style={{ fontWeight: 500, marginTop: '30px', display: 'flex', flexWrap: 'nowrap', justifyContent: 'flex-end' }}>Último Status: {deviceStatus && deviceStatus.date}</h6>
                </Col>
            </Row>
            <Row>
                <Col span={11}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '15px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.32)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '50px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="BLOQUEADOR" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>{deviceOn ? "" : block ? "Desabilitado" : "Habilitado"}</Typography>

                        </Descriptions.Item>

                    </Descriptions>
                </Col>
                <Col span={12} offset={1}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '15px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.32)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '50px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="ROTEIRIZADOR" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>{deviceOn ? "" : roteirizador ? "Desabilitado" : "Habilitado"}</Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '10px' }}
                        size='small'
                        layout='horizontal'
                    >
                        <Descriptions.Item label="Status de Bloqueio" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : block ? "" : deviceStatus && deviceStatus.devicesBloqueado && deviceStatus.devicesBloqueado.substring(0, 1) === "0" ? "Desbloqueado" : "Bloqueado"}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>

                <Col span={12} offset={1}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '10px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Ponto de Parada (Tempo)" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : deviceStatus && deviceStatus.controleParada === 0 ? "Desabilitado" : "Habilitado (" + Math.round((deviceStatus.tempoParada / 10) * 100) / 100 + " min)"}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '1px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >
                        <Descriptions.Item label={"Motivo do Bloqueio"} className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : block ? "" : reasonBlock ? "" : deviceStatus.motivoBloqueio}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '10px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Tipo de Bloqueio" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : block ? "" : deviceStatus && deviceStatus.tipoBlk === 0 ? "Seguro" : "Progressivo"}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>

                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '1px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Tempo para Bloqueio" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : block ? "" : typeBlock ? <h6 style={{ fontSize: 14, fontWeight: 400, color: 'GrayText' }}>Não Aplicável</h6> : deviceStatus && Math.round((deviceStatus.tempoPresenca / 10) * 100) / 100 + "min"}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>

                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '10px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >
                        <Descriptions.Item label="Senha de Ignição" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : deviceStatus && deviceStatus.senhaIgnicao}
                            </Typography>
                        </Descriptions.Item>
                    </Descriptions>

                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '10px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >
                        <Descriptions.Item label="Sensibilidade a Jamming" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : jamming ? "" : String(deviceStatus.jamming).charAt(1) + "" + String(deviceStatus.jamming).charAt(2) + "%"}
                            </Typography>
                        </Descriptions.Item>
                    </Descriptions>

                </Col>
                <Col span={12} offset={1}>
                    <Text style={{fontSize:16, fontWeight: 500}}>Bloqueio Por:</Text>
                    <Descriptions
                        bordered
                        //title={"Bloqueio por: "}
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '0px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Diferença de ID" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : deviceStatus && deviceStatus.idRastreador === 0 ? "Desabilitado" : "Habilitado "}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>

                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        style={{ marginTop: '1px' }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Remoção do Chip" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : deviceStatus && deviceStatus.remSimcard === 0 ? "Desabilitado" : "Habilitado "}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>

                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '1px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Remoção do Rastreador" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : deviceStatus && deviceStatus.faltaStt === 0 ? "Desabilitado" : "Habilitado "}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>
                    <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        labelStyle={{ fontSize: '14px', fontWeight: '720', backgroundColor: 'rgba(80, 154, 204, 0.15)', width: '300px', color: 'black', borderRadius: '2px' }}
                        style={{ marginTop: '1px' }}
                        size='small'
                        layout='horizontal'
                    >

                        <Descriptions.Item label="Detecção de Jamming" className={styles.customDescriptionItem}>
                            <Typography style={{ fontWeight: 600, color: "black", fontSize: "15px" }}>
                                {deviceOn ? "" : jamming ? "Desabilitado" : "Habilitado"}
                            </Typography>
                        </Descriptions.Item>

                    </Descriptions>
                </Col>
            </Row>

        </>
    );
}